import { supabaseService } from './services/supabase';
import { logger } from './logger';
import { Student } from '../types/student';
import { useStore } from './store';

export async function resolveEnrollment(studentId: string, sourceTable: string, targetTable: string) {
  try {
    logger.info('Iniciando resolução de matrícula', { studentId, sourceTable, targetTable });
    
    const { deleteOnlyMode } = useStore.getState();

    if (deleteOnlyMode) {
      // Apenas excluir o registro da tabela de falhas
      const { error: deleteError } = await supabaseService.deleteRecord(sourceTable, studentId);
      if (deleteError) throw deleteError;
      logger.info('Registro excluído com sucesso', { studentId });
    } else {
      // Mover o registro para a tabela de sucesso
      await supabaseService.moveRecord(sourceTable, targetTable, studentId);
      logger.info('Matrícula resolvida com sucesso', { studentId });
    }
  } catch (error) {
    logger.error('Erro ao resolver matrícula:', error as Error);
    throw error;
  }
}

export async function markAsError(
  studentId: string, 
  sourceTable: string, 
  targetTable: string, 
  errorMessage: string
) {
  try {
    logger.info('Marcando matrícula como erro', { studentId, errorMessage });
    await supabaseService.moveRecord(sourceTable, targetTable, studentId);
    await supabaseService.addErrorToRecord(targetTable, studentId, errorMessage);
    logger.info('Matrícula marcada como erro com sucesso', { studentId });
  } catch (error) {
    logger.error('Erro ao marcar matrícula como erro', error as Error);
    throw error;
  }
}

export async function prefetchStudents(): Promise<Student[]> {
  try {
    logger.info('Iniciando pré-carregamento de dados');
    
    // Buscar lista de tabelas
    const { data: tables, error: tablesError } = await supabase
      .from('tabelas_view')
      .select('*');

    if (tablesError) throw tablesError;
    if (!tables) throw new Error('Nenhuma tabela encontrada');

    // Buscar dados de cada tabela em paralelo
    const promises = tables.map(async ({ table_name, table_type }) => {
      const { data, error } = await supabase
        .from(table_name)
        .select('*')
        .order('nome_completo', { ascending: true });

      if (error) {
        logger.error(`Erro ao buscar dados da tabela ${table_name}:`, error);
        return [];
      }

      return (data || []).map(student => ({
        ...student,
        status: table_type as 'success' | 'error',
        originalTable: table_name
      }));
    });

    const results = await Promise.all(promises);
    const allStudents = results.flat();

    logger.info('Pré-carregamento concluído', { 
      totalStudents: allStudents.length 
    });

    return allStudents;
  } catch (error) {
    logger.error('Erro no pré-carregamento', error as Error);
    throw error;
  }
}